import { StockTransferLine } from './stock-transfer-line';

export class StockTransferRequest {
    DocDate: Date = new Date();
    DueDate: Date = new Date();
    Comments: string = '';
    FromWarehouse: string = '';
    ToWarehouse: string = '';
    StockTransferLines: StockTransferLine[] = [];

    constructor(init?: Partial<StockTransferRequest>) {
        if (init) {
            Object.assign(this, init);
        }
    }
}
